import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import logo from "../assets/images/logo.png";
import Swal from "sweetalert2";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import { menuItems, SIDEBAR_BACKGROUND_COLOR } from "../config/menuConfig";
import { withSidebar } from "../context/SidebarContext";

const baseUrl = process.env.REACT_APP_BASE_URL;

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFoodScientistRegistered: false,
      isLicenseLoading: false,
      isInspectionLoading: false,
      isInspectionRegistered: false,
      isUserInfoLoading: false,
      regNumber: "",
      showLicenseModal: false,
      isPayingForLicense: false,
      licenseId: null,
      showRenewalOption: false,
      licenseExpiryDate: null,
      isLoading: true,
      hasLicenseApplication: false,
      licenseStatus: "",
      paymentStatus: "",
      licenseExpired: false,
      licenseExpDate: null,
      rrr: null,
      pendingAssignmentCount: 0
    };
  }

  componentDidMount() {
    this.initializeData();
  }

  initializeData = async () => {
    await Promise.all([
      this.getUserDetails(),
      this.checkLicenseRegistration(),
      this.fetchPendingAssignmentCount()
    ]);
  };

  fetchPendingAssignmentCount = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/v2/user/lead-scientist-assignments/pending`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        this.setState({ pendingAssignmentCount: Array.isArray(data) ? data.length : 0 });
      }
    } catch (error) {
      console.error("Error fetching pending assignments:", error);
      this.setState({ pendingAssignmentCount: 0 });
    }
  };

  checkLicenseRegistration = async () => {
    try {
      const licenseId = localStorage.getItem("licenseId");
      if (!licenseId || licenseId === "0" || licenseId === "null" || licenseId === "undefined") {
        return;
      }
      this.setState({ isLicenseLoading: true });

      const response = await fetch(
        `${baseUrl}/v2/license/${localStorage.getItem("licenseId")}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const responseJson = await response.json();

      if (response.status === 401) {
        this.setState({ isLicenseLoading: false });
        Swal.fire({
          title: "Session Expired",
          text: "Session expired. Please login",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          this.props.history.push("/login");
        });
        this.setState({
          isLicenseLoading: false,
          license: responseJson.licenseNumber,
          licenseId: responseJson.licenseId,
          licenseExpiryDate: responseJson.licenseExpDate,
        });
      } else {
        this.setState({
          isLicenseLoading: false,
          license: responseJson.licenseNumber,
          licenseId: responseJson.licenseId
        });
      }
    } catch (error) {
      this.setState({ isLicenseLoading: false });
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  getUserDetails = async () => {
    try {
      this.setState({ isUserInfoLoading: true });
      const response = await fetch(
        `${baseUrl}/v2/dashboard/user/${localStorage.getItem("userid")}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const responseJson = await response.json();

      if (response.status === 401) {
        this.setState({ isUserInfoLoading: false });
        Swal.fire({
          title: "Session Expired",
          text: "Session expired. Please login",
          icon: "error",
          confirmButtonText: "OK",
        }).then(() => {
          this.props.history.push("/login");
        });
      } else {
        const licenseInformation = responseJson.licenseInformation;
        const registrationInfo = responseJson.registrationInformation;

        this.setState({
          regNumber: registrationInfo.csfnNumber,
          registrationStatus: registrationInfo.applicationStatus,
          isUserInfoLoading: false,
          paymentStatus: licenseInformation.paymentStatus,
          licenseStatus: licenseInformation.applicationStatus,
          hasLicenseApplication: licenseInformation.hasLicenseApplication,
          licenseExpired: licenseInformation.licenseExpiry,
          licenseId: licenseInformation.licenseId,
          licenseExpDate: licenseInformation.expiryDate,
          rrr: licenseInformation.rrr,
          isLoading: false
        });
      }
    } catch (error) {
      this.setState({ isUserInfoLoading: false });
      Swal.fire({
        title: "Error!",
        text: error.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  handleToggle = () => {
    const { sidebar } = this.props;
    if (sidebar) {
      sidebar.close();
    }
  };

  // Check if a route is active using React Router's location
  isRouteActive = (path) => {
    const { location } = this.props;
    if (!location) return false;
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  renderMenuItem = (item, variant = 'desktop') => {
    const isActive = this.isRouteActive(item.path);
    const { pendingAssignmentCount } = this.state;

    // Hide assignment requests menu item if no pending assignments
    if (item.key === 'lead-scientist-assignments' && pendingAssignmentCount === 0) {
      return null;
    }

    const showBadge = item.key === 'lead-scientist-assignments' && pendingAssignmentCount > 0;

    if (variant === 'mobile') {
      return (
        <Nav.Link key={item.key} className="text-light">
          <Link className="text-light text-decoration-none" to={item.path}>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <i className="material-icons opacity-10 me-2">{item.icon}</i>
                {item.label}
              </div>
              {showBadge && (
                <span
                  style={{
                    backgroundColor: '#dc3545',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '2px 8px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    minWidth: '22px',
                    textAlign: 'center'
                  }}
                >
                  {pendingAssignmentCount}
                </span>
              )}
            </div>
          </Link>
        </Nav.Link>
      );
    }

    return (
      <li key={item.key} className="nav-item">
        <Link
          to={item.path}
          className={isActive ? "active nav-link" : "nav-link"}
        >
          <div className="text-center me-2 d-flex align-items-center justify-content-center">
            <i className="material-icons opacity-10 text-light">{item.icon}</i>
          </div>
          <span className="nav-link-text ms-1 text-light">{item.label}</span>
          {showBadge && (
            <span
              style={{
                backgroundColor: '#dc3545',
                color: 'white',
                borderRadius: '50%',
                padding: '2px 8px',
                fontSize: '11px',
                fontWeight: 'bold',
                marginLeft: '8px',
                minWidth: '20px',
                textAlign: 'center',
                display: 'inline-block'
              }}
            >
              {pendingAssignmentCount}
            </span>
          )}
        </Link>
      </li>
    );
  };

  renderDesktopSidebar() {
    return (
      <aside
        className="sidenav navbar navbar-vertical navbar-expand-xs fixed-start d-none d-md-block"
        id="sidenav-main"
        style={{
          margin: "0 !important",
          borderRadius: "0",
          overflow: "hidden",
          backgroundColor: SIDEBAR_BACKGROUND_COLOR
        }}
      >
        <div className="sidenav-header" style={{ backgroundColor: SIDEBAR_BACKGROUND_COLOR }}>
          <a className="navbar-brand d-flex justify-content-center text-center m-0" href="#" target="_blank" rel="noopener noreferrer">
            <img src={logo} className="navbar-brand-img h-100" alt="main_logo" />
          </a>
        </div>
        <hr className="horizontal light mt-0 mb-0" />

        <div className="collapse navbar-collapse w-auto" style={{ backgroundColor: SIDEBAR_BACKGROUND_COLOR }}>
          <ul className="navbar-nav">
            {menuItems.map((item) => this.renderMenuItem(item, 'desktop'))}
          </ul>
        </div>
      </aside>
    );
  }

  renderMobileSidebar() {
    const { sidebar } = this.props;
    const isOpen = sidebar?.isOpen ?? false;

    return (
      <Navbar
        expand="lg"
        className={`d-md-none sm-mobile-sidebar ${isOpen ? "d-block" : "d-none"}`}
        variant="dark"
        style={{ backgroundColor: SIDEBAR_BACKGROUND_COLOR }}
      >
        <Container style={{ backgroundColor: SIDEBAR_BACKGROUND_COLOR, padding: "18px 18px 0 18px" }}>
          <Navbar.Brand className="text-light font-weight-bold">
            NiCFoST
          </Navbar.Brand>
          <Navbar.Toggle onClick={this.handleToggle} className="bg-dark">X</Navbar.Toggle>

          <Nav className="flex-column w-100">
            {menuItems.map((item) => this.renderMenuItem(item, 'mobile'))}
          </Nav>
        </Container>
      </Navbar>
    );
  }

  render() {
    const { isLoading } = this.state;

    if (isLoading) {
      return (
        <center>
          <Spinner animation="border" variant="primary" size="sm" />
        </center>
      );
    }

    return (
      <>
        {this.renderDesktopSidebar()}
        {this.renderMobileSidebar()}
      </>
    );
  }
}

export default withRouter(withSidebar(Sidebar));
